export const LinkedinIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7769_126919)">
        <path
          d="M12 22.8184C17.5228 22.8184 22 18.3412 22 12.8184C22 7.29551 17.5228 2.81836 12 2.81836C6.47715 2.81836 2 7.29551 2 12.8184C2 18.3412 6.47715 22.8184 12 22.8184Z"
          fill="#0A66C2"
        />
        <path
          d="M17.9748 13.6236V17.7464H15.5846V13.8999C15.5846 12.9341 15.2395 12.2745 14.374 12.2745C13.7136 12.2745 13.3212 12.7186 13.1479 13.1485C13.085 13.3022 13.0688 13.5156 13.0688 13.7311V17.7462H10.6783C10.6783 17.7462 10.7104 11.2315 10.6783 10.5572H13.069V11.5759C13.0642 11.5839 13.0574 11.5918 13.0531 11.5994H13.069V11.5759C13.3866 11.0871 13.9531 10.3883 15.2232 10.3883C16.7958 10.3883 17.9748 11.4158 17.9748 13.6236ZM8.17771 7.0918C7.36003 7.0918 6.82507 7.62854 6.82507 8.33373C6.82507 9.02395 7.34452 9.5762 8.14633 9.5762H8.16184C8.99556 9.5762 9.51394 9.02395 9.51394 8.33373C9.49807 7.62854 8.99556 7.0918 8.17771 7.0918ZM6.96715 17.7464H9.35671V10.5572H6.96715V17.7464Z"
          fill="#F1F2F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_7769_126919">
          <rect width="20" height="20" fill="white" transform="translate(2 2.81836)" />
        </clipPath>
      </defs>
    </svg>
  );
};
